export const SECURITY_CONTACT_EMAIL = "security@zenfresh.com";

export const LAST_REVIEWED = "August 2026";

export interface ScopeItem {
  label: string;
  inScope: boolean;
}

export const SCOPE: ScopeItem[] = [
  { label: "This portfolio website (all pages under this domain)", inScope: true },
  { label: "Denial-of-service, spam, or volumetric testing against any endpoint", inScope: false },
  { label: "Social engineering or phishing directed at ZenFresh staff", inScope: false },
  { label: "Physical access attempts against ZenFresh offices or facilities", inScope: false },
  { label: "Third-party services this site links to but doesn't control (e.g. Wikimedia Commons)", inScope: false },
];
